const KEEP_MODAL_TRANSITIONS = [
  {
    from: '/campaigns',
    to: '/campaign',
  },
  {
    from: '/campaign',
    to: '/campaign',
  },
];

export const shouldKeepModalOpen = (from?: string, to?: string) => {
  return KEEP_MODAL_TRANSITIONS.some(
    (t) => from?.startsWith(t.from) && to?.startsWith(t.to),
  );
};
